export default __webpack_public_path__ + "static/media/cardimage.627a59d3.svg";